// TODO: https://github.com/combinaut/sparkle/issues/31058 removes this legacy landing view with the legacy DoctorFinder router.
import "#/legacy/namespaces.js";
import "./wizard_step.js";

/** Temporary restoration and URL compatibility for the Vue-owned landing form. */
DoctorFinder.Views.WizardStep1 = class WizardStep1 extends DoctorFinder.Views.WizardStep {
  static {
    this.prototype.template = false;
  }

  initialize(options = {}) {
    super.initialize(options);
    this.locationSettings = options.locationSettings || {};
    this.finderAdapter = options.finderAdapter;
    this.finderAdapter.updateLandingDraft({ view: "bio", sort: "best_match", lat: "", lng: "" });
    if (options.title) {
      this.$('[data-doctor-finder-landing-page-content="title"]').text(options.title);
    }
    // Embed-supplied server content remains outside the store and Vue-owned insertion targets.
    if (options.disclaimer) {
      this.$('[data-doctor-finder-landing-page-content="disclaimer"]').html(options.disclaimer);
    }
  }

  setInsurancePlan(value) {
    this.finderAdapter.updateLandingDraft({ insurance_plan: value });
  }

  applyInsurancePlanFilter(value) {
    this.setInsurancePlan(value);
  }

  setLocation(location) {
    if (location) {
      this.finderAdapter.updateLandingDraft(location, { transientLocation: false });
    }
  }

  applyLocationFilter(location) {
    this.setLocation(location);
  }

  persistLocation(location) {
    this.finderAdapter.updateLandingDraft(location, { explicitlySelected: true });
  }

  updateRenderedLocation() {}

  decorateSearchLinks() {
    const newSearchParams = this.getLinkDecoratorSearchParams();

    return this.$el.find('[data-doctor-finder-behaviour="set-filters"][href]').each((index, element) => {
      const $element = jQuery(element);
      // Resolve against the page origin so a relative href (allowed for caller-provided tile hrefs)
      // doesn't throw; against a valid origin an absolute href ignores the base. Guard the parse anyway:
      // in an opaque-origin context (e.g. a srcdoc preview iframe where origin is the literal "null") the
      // invalid base is parsed first and makes `new URL` throw for any href, so skip just that link
      // instead of aborting the whole pass — mirrors absoluteResultsUrl's handling.
      let url;
      try {
        url = new URL($element.attr("href"), window.location.origin);
      } catch {
        return;
      }

      // Remove existing filters managed by the landing-page controls
      for (const key of ["zip", "lat", "lng", "distance", "insurance_plan"]) {
        url.searchParams.delete(key);
      }

      // Apply new filters
      newSearchParams.forEach((value, key) => url.searchParams.set(key, value));

      // Overwrite existing href with updated url
      return $element.attr("href", url.toString());
    });
  }

  // Carries the landing page's required filters onto a profile the omnisearch jumps straight to,
  // so the profile scopes its address list to the plan the visitor is searching as instead of
  // rendering every address. Only `zip` and `insurance_plan` travel: a profile geocodes the zip to
  // order its addresses and scopes them by the plan, and reads none of the other search filters.
  // Gated on the required-filters finders, which are the only ones guaranteed to have both.
  decorateProfileUrl(url) {
    if (!this.locationSettings.filterOptions?.required_filters_modal) {
      return url;
    }

    // Same opaque-origin guard as decorateSearchLinks: skip decorating rather than throw.
    let profileUrl;
    try {
      profileUrl = new URL(url, window.location.origin);
    } catch {
      return url;
    }

    const searchParams = this.getLinkDecoratorSearchParams();
    for (const key of ["zip", "insurance_plan"]) {
      const value = searchParams.get(key);
      if (value) {
        profileUrl.searchParams.set(key, value);
      }
    }

    return profileUrl.toString();
  }

  getLinkDecoratorSearchParams() {
    const draft = this.finderAdapter.landingDraft ?? {};
    const params = new URLSearchParams();
    for (const key of ["zip", "lat", "lng", "distance", "insurance_plan"]) {
      const value = draft[key];
      if (value != null && value !== "") {
        params.set(key, value);
      }
    }
    return params;
  }
};
